<app-view-title mode="soft"
                Title="{{ 'Intellitrailer.Rental.NFCNoLock.Headline' | translate : 'Scan the trailer' }}">
</app-view-title>

@if (appSvc.Device.Nfc == 2) {
<view-content [centered]="true">
  <app-nfcRequired></app-nfcRequired>
</view-content>
}
@else {
<view-content [centered]="true">
  <h2>
   {{ 'Intellitrailer.Rental.NFCNoLock.lblYourTrailer' | translate : 'Your trailer' }}: {{ booking?.RentalObject?.Alias ? booking?.RentalObject?.Title + ' - ' + booking?.RentalObject?.Alias : booking?.RentalObject?.Title }}
  </h2>

  <!-- Searching -->
  @if (isWaiting) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.NFCNoLock.headGuide_a' | translate : 'Find this label on the trailer' }}</h2>
    <img src="/Images/lockless.png" />
    <p>{{ 'Intellitrailer.Rental.NFCNoLock.msgGuide_b' | translate : 'This trailer is equipped with a system to identify it and to control the tracking mechanism.' }}</p>
    <p>{{ 'Intellitrailer.Rental.NFCNoLock.msgGuide_c' | translate : 'Please locate the corresponding area to scan on the front of the trailer. And click the button below.' }}</p>
  </app-card>
  }

  <!-- Scanning -->
  @if (isSearching) {
  <app-card>
    @if (count <= 30) {
    <div class="spinner-container">
      <mat-progress-spinner diameter="75"
                            class="spinner"
                            mode="determinate"
                            [value]="count * (3 + 1.0 / 3.0)">
      </mat-progress-spinner>
      <h1 style="font-size: 24px">{{ 30 - count }}</h1>
    </div>
    }
    <h2>{{ 'Intellitrailer.Rental.NFCNoLock.SearchingNFC4' | translate : 'Searching for trailer' }}...</h2>
    <p>{{ 'Intellitrailer.Rental.NFCNoLock.UnlockingInfoNFC_android' | translate: 'Place the back of your phone on the correct area of the trailer. You might need to move it around a bit.' }}</p>


    <p>{{ 'Intellitrailer.Rental.NFCNoLock.UnlockingInfoNFC_android' | translate: 'Place the back of your phone on the correct area of the trailer. You might need to move it around a bit.' }}</p>
    @if(count < 10) {
    <img src="/Images/lockless.gif" />
    } 
    @else
    {
    <img src="/Images/lockless_moveAround.gif" />
    }
  </app-card>
  }

  <!-- Confirmation-->
  @if(hasCompleted) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.NFCLock.LockOpenTitle3' | translate : 'Thank you!' }}</h2>
    <p>{{ 'Intellitrailer.Rental.NFCLock.LockOpenInstructions3' | translate : 'The trailer was scanned successfully' }}</p>
</app-card>
  }
  <!-- Cancelled Scanning -->
  @if (hasFailed && failReason == 3) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.NFCNoLock.TitleScanCancelledNFC4' | translate : 'Scanning Canceled' }}</h2>
    <p>{{ 'Intellitrailer.Rental.NFCNoLock.ScanCancelledInfo' | translate : 'The NFC scan was canceled. Please identify the correct area on the trailer and try again' }}</p>
    <img src="/Images/lockless.png" />
  </app-card>
  }
  <!-- No tag found -->
  @if (hasFailed && failReason == 2) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.NFCNoLock.TitleLockNotOpenNFC4' | translate : 'Failed to find the trailer' }}</h2>
    <p>{{ 'Intellitrailer.Rental.NFCNoLock.NotFoundInfo4' | translate : 'Make sure that you are holding your phone correctly, with the reader towards the trailer.' }}</p>
    <img src="/Images/lockless_moveAround.gif" />
  </app-card>
  }

  <!-- Wrong tag found -->
  @if (hasFailed && failReason == 1) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.NFCNoLock.headWrongTag4' | translate : 'Wrong trailer identified!' }}</h2>
    <p>{{ 'Intellitrailer.Rental.NFCNoLock.msgWrongTag4' | translate : 'The trailer you have scanned was not the expected one. Please verify that you are at the correct trailer and try again.' }}</p>
  </app-card>
  }
</view-content>
}

@if (appSvc.Device.Nfc != 2) {
<view-actions>
  @if (isWaiting) { <button mat-raised-button (click)="beginSearch()">{{ 'Intellitrailer.Rental.NFCNoLock.cmdStart' | translate : 'Start scanning' }}</button> }
  @if (hasFailed) { <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NFCNoLock.Retry' | translate : 'Retry' }}</button> }
  @if (hasCompleted) { <button mat-raised-button (click)="next()"> {{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }} </button> }
</view-actions>
}
